import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { SelectionMode, clearPins, clearSelection, exitCompareMode } from '~app/actions/search';

class CompareModal extends Component {

  onClose() {
    this.props.clearPins();
    this.props.clearSelection();

    this.props.exitCompareMode();
  }

  render() {
    return (
      (this.props.selectionMode !== SelectionMode.select) &&

      <div className="CompareModal">
        <p className="CompareModal__text">
          Select a biome to compare to:
        </p>
        <p className="CompareModal__text">
          {this.props.locationInfo.displayName}
        </p>
        <button
          className={classNames("CompareModal__cancelButton", {
                                  "CompareModal__cancelButton--disabled": this.props.isBusy,
                                })}
          onClick={::this.onClose}
        >
          Cancel
        </button>
      </div>
    );
  }
}

CompareModal.propTypes = {
  locationInfo: PropTypes.object,
  selectionMode: PropTypes.number.isRequired,
  isBusy: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  locationInfo: state.search.selectedLocationInfo,
  selectionMode: state.search.selectionMode,
  isBusy: state.busy.isBusy,
});

const mapDispatchToProps = {
  clearPins,
  clearSelection,
  exitCompareMode,
};

export { CompareModal };
export default connect(mapStateToProps, mapDispatchToProps)(CompareModal);



// WEBPACK FOOTER //
// ./src/components/CompareModal.js